import { motion } from 'framer-motion';
import { FileText, List } from 'lucide-react';

import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';

interface ViewModeToggleProps {
  viewMode: 'transcript' | 'summary';
  onViewModeChange: (mode: 'transcript' | 'summary') => void;
}

export const ViewModeToggle = ({ viewMode, onViewModeChange }: ViewModeToggleProps) => {
  const isTranscriptMode = viewMode === 'transcript';
  const actionText = isTranscriptMode ? 'View Summary' : 'View Transcript';
  const Icon = isTranscriptMode ? FileText : List;
  const targetMode = isTranscriptMode ? 'summary' : 'transcript';

  return (
    <div className="absolute top-4 right-8 z-10">
      <motion.button
        onClick={() => {
          if (targetMode === 'summary') {
            trackCustomEvent(TrackingEvents.ViewTranscriptSummary);
          }
          onViewModeChange(targetMode);
        }}
        className="flex h-8 items-center gap-2 rounded-md border border-blue-500 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-800 shadow-md transition-all duration-200 hover:border-blue-600 hover:bg-blue-100 hover:shadow-lg"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        transition={{ duration: 0.1 }}
      >
        <motion.div
          key={viewMode}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
          className="flex items-center gap-2"
        >
          <Icon className="h-4 w-4" />
          <span>{actionText}</span>
        </motion.div>
      </motion.button>
    </div>
  );
};
